import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

export default async function getRecommendedList(
  { state, apiClient },
  { count, filters, reloadRecommendations },
) {
  typeCheck('count::Maybe PositiveNumber', count);
  typeCheck('filters::NonEmptyObject', filters);

  const recommendedListingsStateCursor = state.select(['recommendedListings']);
  const { page, isFullyLoaded } = recommendedListingsStateCursor.get();
  if (isFullyLoaded && !reloadRecommendations) {
    return;
  }

  const params = {
    page: page,
    count: count || recommendedListingsStateCursor.get(['count']),
    filters: {
      ...state.get(['currentUser', 'searchFilters']),
      addressZip: filters.addressZip,
      excludeIds: filters.viewedListingIds,
      dataSource: filters.dataSource,
    },
  };

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LIST,
    state: state,
    payload: params,
    queryId: 'list',
    onSuccess({ data }) {
      recommendedListingsStateCursor.set('records', data);
      recommendedListingsStateCursor.set('isFullyLoaded', data.length > 0);
    },
    onError() {
      recommendedListingsStateCursor.set('isFullyLoaded', false);
    },
  });
}
